import React from 'react';
export function Hero() {
  return <div className="max-w-3xl mx-auto px-4 py-6" data-id="element-79">
      <div className="text-center mb-6" data-id="element-80">
        <div className="text-xs text-gray-500 mb-6" data-id="element-81"></div>
      </div>
      <h1 className="text-2xl md:text-3xl font-bold text-center mb-4 leading-tight" data-id="element-82">
        Why I Kept Crashing at 3 PM (And Why My Doctor Never Caught It)
      </h1>
      <div className="flex items-center justify-center mb-6 text-sm" data-id="element-83">
        <div className="flex items-center" data-id="element-84">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xpGDfs9kBXoEtYmJPJ7rbA/Untitled_design_%2863%29.png" alt="Michael Thompson" className="w-10 h-10 rounded-full object-cover mr-3" data-id="element-85" />
          <div data-id="element-86">
            <p className="font-medium" data-id="element-87">
              By Michael Thompson, Health Research Journalist
            </p>
            <p className="text-gray-500" data-id="element-88">Updated January 2025</p>
          </div>
        </div>
      </div>
      <div className="bg-gray-100 p-5 rounded-lg mb-8 italic text-center" data-id="element-89">
        <p className="text-lg font-medium" data-id="element-90">
          "After two years of trying everything, a chance conversation finally
          explained what was really happening."
        </p>
      </div>
      <div className="my-8" data-id="element-91">
        <img src="https://cdn.magicpatterns.com/uploads/agZEptJgYzUAqesWpfiHss/gemini-generated-image-jc8iuzjc8iuzjc8i.jpg" alt="Professional man struggling during meeting" className="w-full h-auto rounded-lg shadow-md" data-id="element-92" />
      </div>
    </div>;
}